import React from 'react'
// import './Home.scss'
import { useSetBodyBackgrounds } from '../../../shared/bodyBackgrounds'
import { Link } from 'react-router-dom'

const Home = () => {
    // Call Custom Hook to set Body Backgrounds
    useSetBodyBackgrounds('home-bg')

    return (
        <div className='container'>
            <div id='home' className='maincontent'>
                <section className='hero'>
                    <h1 className='hero__heading'>
                        So you want to travel to
                        <span className='hero__heading-large'>Space</span>
                    </h1>

                    <p className='hero__description'>
                        Let’s face it; if you want to go to space, you might as
                        well genuinely go to outer space and not hover kind of
                        on the edge of it. Well sit back, and relax because
                        we’ll give you a truly out of this world experience!
                    </p>
                </section>
                <div className='hero__btn-container'>
                    <Link to={'destination'}>
                        <button className='hero__btn-main'>Explore</button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default Home
